(() => {
  const SWATCH = { schwarz: '#333232', beige: '#fad6a5', dunkelblau: '#293fae', tuerkis: '#30abd1', turkis: '#30abd1' };

  document.querySelectorAll('[data-mc-product]').forEach((info) => {
    const section = info.closest('section') || document;

    /* Galerie : vignettes (desktop) et défilement (mobile) */
    const items = section.querySelectorAll('[data-mc-gallery-list] > li');
    const thumbs = section.querySelectorAll('[data-mc-thumb]');
    const show = (i) => {
      items.forEach((li, k) => li.classList.toggle('is-active', k === i));
      thumbs.forEach((t, k) => { const b = t.querySelector('button'); if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
      const list = section.querySelector('[data-mc-gallery-list]');
      if (list && window.innerWidth < 750 && items[i]) list.scrollTo({ left: items[i].offsetLeft, behavior: 'smooth' });
    };
    thumbs.forEach((t) => t.addEventListener('click', () => show(Number(t.dataset.mcThumb))));

    /* Offre par paliers */
    const offer = info.querySelector('[data-mc-offer]');
    const paintSwatch = (sel) => {
      const opt = sel.options[sel.selectedIndex];
      const sw = sel.parentElement.querySelector('[data-mc-swatch]');
      if (sw && opt) sw.style.setProperty('--kaching-swatch-color', SWATCH[opt.dataset.color] || '#fff');
    };
    const syncGifts = () => {
      if (!offer) return;
      const sel = offer.querySelector('.kaching-bundles__bar--selected');
      const qty = sel ? Number(sel.dataset.qty) : 1;
      offer.querySelectorAll('[data-mc-gift]').forEach((g) => {
        const on = qty >= Number(g.dataset.min);
        g.classList.toggle('kaching-bundles__progressive-gifts__gift--locked', !on);
        g.querySelector('[data-unlocked]').hidden = !on;
        g.querySelector('[data-locked]').hidden = on;
      });
    };
    if (offer) {
      offer.querySelectorAll('[data-mc-tier]').forEach((bar) => {
        bar.addEventListener('click', (e) => {
          if (e.target.closest('select')) return;
          offer.querySelectorAll('[data-mc-tier]').forEach((b) => b.classList.toggle('kaching-bundles__bar--selected', b === bar));
          syncGifts();
        });
      });
      offer.querySelectorAll('[data-mc-unit]').forEach((sel) => { paintSwatch(sel); sel.addEventListener('change', () => paintSwatch(sel)); });
      offer.querySelectorAll('[data-mc-upsell]').forEach((u) => u.addEventListener('click', () => {
        u.classList.toggle('is-checked');
        u.querySelector('[role="checkbox"]').setAttribute('aria-checked', u.classList.contains('is-checked'));
      }));
      syncGifts();
    }

    /* Ventes additionnelles (interrupteurs) */
    info.querySelectorAll('[data-mc-xsell]').forEach((b) => b.addEventListener('click', () => b.setAttribute('aria-checked', b.getAttribute('aria-checked') !== 'true')));

    /* Sélecteur de variante simple */
    const variantsEl = info.querySelector('[data-mc-variants]');
    const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    const currentVariant = () => {
      const opts = [...info.querySelectorAll('[data-mc-option]')].map((s) => s.value);
      if (!opts.length) return variants[0];
      return variants.find((v) => v.options.every((o, i) => o === opts[i])) || variants[0];
    };

    /* Ajout au panier */
    const atc = info.querySelector('[data-mc-atc]');
    if (atc) atc.addEventListener('click', async () => {
      const items = [];
      const add = (id, q) => { const it = items.find((x) => x.id === id); if (it) it.quantity += q; else items.push({ id, quantity: q }); };
      const sel = offer && offer.querySelector('.kaching-bundles__bar--selected');
      if (sel) {
        const units = [...sel.querySelectorAll('[data-mc-unit]')];
        if (units.length) units.forEach((u) => add(Number(u.value), 1));
        else add(currentVariant().id, Number(sel.dataset.qty));
        const qty = Number(sel.dataset.qty);
        offer.querySelectorAll('[data-mc-gift]').forEach((g) => { if (qty >= Number(g.dataset.min)) add(Number(g.dataset.mcGift), Number(g.dataset.giftQty)); });
        offer.querySelectorAll('[data-mc-upsell].is-checked').forEach((u) => add(Number(u.dataset.mcUpsell), 1));
      } else {
        add(currentVariant().id, 1);
      }
      info.querySelectorAll('[data-mc-xsell][aria-checked="true"]').forEach((b) => add(Number(b.dataset.mcXsell), 1));
      atc.classList.add('loading'); atc.disabled = true;
      await window.mcAddToCart(items);
      atc.classList.remove('loading'); atc.disabled = false;
    });

    /* Barre d'achat fixe */
    const sticky = document.querySelector('[data-mc-sticky]');
    if (sticky && atc) {
      const obs = new IntersectionObserver(([e]) => { sticky.style.transform = (!e.isIntersecting && e.boundingClientRect.top < 0) ? 'translateY(0)' : 'translateY(110%)'; });
      obs.observe(atc);
      sticky.querySelector('[data-mc-sticky-btn]').addEventListener('click', () => (offer || atc).scrollIntoView({ behavior: 'smooth', block: 'center' }));
    }
  });
})();
